<span class="broker-name-display">
  <span
    class="broker-name-text"
    nz-tooltip
    nzTooltipTitle="{{ brokerItem.name }}"
    nzTooltipPlacement="bottomLeft"
    [nzTooltipMouseEnterDelay]="0.3"
    [nzTooltipOverlayStyle]="{
      fontSize: '11px',
      padding: '0px',
      background: '#999'
    }"
    (click)="onClickBrokerName()"
  >
    {{ brokerItem.name }}
  </span>

  <span class="icons-container">
    <!-- order =  info - excluded - custom - cplus -->

    <va-icon
      class="pad-icon"
      *ngIf="showCurrentViewInfo"
      title="Broker does not have current view on company."
      style="color: green;"
      name="info-circle"
    >
    </va-icon>

    <img
      class="pad-icon"
      *ngIf="brokerItem.excluded == true"
      [src]="assets + '/icon-excluded.png'"
      title="Excluded from consensus"
    />

    <img
      class="pad-icon"
      *ngIf="this.shouldCCShow"
      [src]="assets + '/custom_consensus.png'"
    />

    <img
      class="pad-icon"
      *ngIf="brokerItem.pvt_broker && shouldCPlusShow"
      [src]="assets + '/consensus_plus_icon.png'"
    />
  </span>
</span>
